module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJElEQVQ4ja3VPUoDURTF8V9eJGvwo3UHamFnaRnBpBF3oKVGVxA0Iha6Axsd1LgAS60UxTql4e1BECxmBiYyxJDJgWFmLuf95w68e14txqhEDTSzax2L+MYX3vGAx6w2oloJcAunWC77UkEDdHBfLIbCcx0nmeE/mMxzl62p58W5gqGLgwlAf3WY3TvFDltTworQ7RzYwPk4d++ja/Npw0t8Hme7QKMWY9zBdYXuitoN0q0xVhN2CM2AtRl0lms1YH6GwIWgZLdXUUDp7E2pGPA5Q+BrQH+GwH5AIk2RqhoiydOmjZuKwDaSfJZvcVYB1pP+6Uh8HeFyCtgVjvOXIvAH+9LUGEwAGkhTai9bi/LEJk2gljS9V7CU1Yd4kx4BiZKh+AW0NUV4nBq5UAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/contest/i.png
// module id = Lliz
// module chunks = 1